import { initContract } from "@ts-rest/core";
import {
	CalendarEventsListDto,
	listCalendarEventsInput,
} from "../validators/calendar.validator";

const c = initContract();

export const calendarContract = c.router({
	getCalendarEvents: {
		method: "GET",
		path: "/calendars/events",
		responses: {
			200: c.type<CalendarEventsListDto>(),
		},
		query: listCalendarEventsInput,
		summary: "Get user calendar events",
	},
});
